import type { CubeFaceColors } from '@/core/modules/cube/types'

export const CUBE_FACE_COLORS: CubeFaceColors = {
	topFace: 0xff5733, // Orange
	leftFace: 0x3399ff, // Blue
	rightFace: 0xffd700 // Yellow
}
